module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "IBM_i.c69401d6.png";